import { Button } from "@/components/ui/button";
import { ShoppingCart } from "lucide-react";
import { useEffect, useState } from "react";
import CheckoutModal from "@/components/CheckoutModal";
import { sendPixelEvent } from "@/lib/pixelXApp";
import * as Sentry from '@sentry/react';

const StickyMobileCTA = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      // Show sticky CTA after scrolling 300px
      setIsVisible(window.scrollY > 300);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleCheckout = async () => {
    Sentry.addBreadcrumb({
      category: 'ui',
      message: 'CTA button clicked',
      level: 'info',
      data: {
        component: 'StickyMobileCTA',
        variant: 'A',
      },
    });
    
    try {
      await sendPixelEvent('AddToCart');
      setModalOpen(true);
    } catch (error) {
      Sentry.captureException(error, {
        tags: { action: 'open_checkout_modal' },
      });
    }
  };

  if (!isVisible) return null;

  return (
    <>
      <div className="fixed bottom-0 left-0 right-0 z-50 p-4 bg-background/95 backdrop-blur border-t shadow-lg lg:hidden animate-slide-up">
        <Button 
          onClick={handleCheckout}
          size="lg"
          className="w-full bg-gradient-warm hover:shadow-hover transition-all duration-300 text-lg h-14"
        >
          <ShoppingCart className="mr-2 h-5 w-5" />
          Comprar por R$ 29,90
        </Button>
      </div>
      
      <CheckoutModal open={modalOpen} onOpenChange={setModalOpen} />
    </>
  );
};

export default StickyMobileCTA;
